/**
 * @typedef {import('antd/es/config-provider').ConfigProviderProps} ConfigProviderProps
 */

import React from 'react';

import { ConfigProvider as ConfigProviderCore } from 'antd';

/**
 * @description ConfigProvider provides a uniform configuration support for components. Underlying it is using the antd config-provider component.
 *
 * @author  Hemant Kumar Goyal <@hemantkumar.goyal>
 *
 * @reference https://ant.design/components/config-provider
 *
 * @param {ConfigProviderProps}  props https://ant.design/components/config-provider
 *
 * @returns {React.component}
 */

const ConfigProvider = (props) => {
	const { children, ...restProps } = props;

	return <ConfigProviderCore {...restProps}>{children}</ConfigProviderCore>;
};

export default ConfigProvider;
